// @ts-check

import { MapView, Mappedin, MappedinMap, getVenue } from "@mappedin/mappedin-js";
import { useEffect, useState } from "react";
// import { createMapCalculations } from "../mapCalculations";


/**
 * @typedef {import("../liveMapPageTypes").Pl_Map} Pl_Map
 * 
 */




/**
 * @param {MapView | undefined} mapView
 */
export default function usePrepareMap(mapView) {

  // /** @param {number} minZoom */
  // let limitToMinZoom = function (minZoom) {
  //   if (!mapView?.currentMap.scale) {
  //     return 300;
  //   }
  //   return minZoom * mapView.currentMap.scale * 7.9; // Magic number.
  // };



  useEffect(() => {
    
    // console.log('VENUE LOAD ===> ');

    
    if (!mapView) {
      return;
    }
    
    let venue = mapView.venue;
    if (!venue) {
      return;
    }
    
    console.log('usePrepareMap => VENUE LOAD ===> DO!', venue, venue.maps[0].name);
    
    
    // // DEV DEBUG BLOCK
    // {
      
    //   // @ts-ignore
    //   if (window.venue !== venue) {
    //     console.log('usePrepareMap => VENUE LOAD ===> window.venue !== venue');
    //   }
    //   // @ts-ignore
    //   if (window.mapView !== mapView) {
    //     console.log('usePrepareMap => VENUE LOAD ===> window.mapView !== mapView');
    //   }
      
    //   // @ts-ignore
    //   window.venue = venue;
    //   // @ts-ignore
    //   window.mapView = mapView;
      
    // }
    
    

    recolorMap(mapView);
    addMapInteractivity(mapView);
    setupCamera(mapView);





  // }, [venue, mapView]);
  }, [mapView]);


  return [
    recolorMap,
    addMapInteractivity
  ];
}






/**
 * @param { MapView } mapView
 */
function setupCamera(mapView) {
  
    /** @type {Pl_Map} */
    let map = mapView.currentMap;
    
    // console.log('XXXXXXXXXXXXXXXXXXX => map ===> ', map);
    // console.log('XXXXXXXXXXXXXXXXXXX => map.pl_Metadata ===> ', map.pl_Metadata);
      
    
    // let mapCalculations = createMapCalculations(mapView.currentMap);
    // console.log('mapCalculations ===> ', mapCalculations);
    
    let mapCalculations = map.pl_Metadata?.mapCalculations;
    // console.log('mapCalculations ===> ', mapCalculations);
    
    if (!mapCalculations) {
      return;
    }
    
    // // @ts-ignore
    // mapView.pl_metadata = {
    //   mapCalculations,
    // };
    
    // @ts-ignore
    // console.log('mapView.currentMap.pl_Metadata ===> ', mapView.currentMap.pl_Metadata);

    // venue?.maps.forEach((map) => {
    //   console.log('map ===> ', map);
      
    //   // @ts-ignore
    //   console.log('ZZZZZZZZZZZZZZZ map.pl_Metadata ===> ', map.pl_Metadata);
    // });
  
    
    

    // M
    // let coordinate = map.createCoordinateByXY(1723, 2246);
    
    // DEMO
    // let coordinate = map.createCoordinateByXY(2492, 1275);
    
    // AUTO
    // let coordinate = map.createCoordinateByXY(mapCalculations.centerX -150, mapCalculations.centerY + 700);

    // mapView.Camera.set({
    //   rotation: -0.3,
    //   tilt: 0.9,
    //   zoom: 2500,
    //   position: coordinate
    // });
    
    mapView.Camera.set(mapCalculations.camera_Default);


    // console.log(' --------------------------------------------          ===> ');
    // console.log('map Max Zoom ===> ', mapView.Camera.maxZoom, 'map Min Zoom ===> ', mapView.Camera.minZoom);


    // addLabels(mapView);


    // console.log('mapView?.currentMap.scale ===> ', mapView?.currentMap.scale);

    // let minZoom = limitToMinZoom(375);
    let minZoom = mapCalculations.minZoomLimit;
    // console.log('calculated minZoom ===> ', minZoom);
    mapView.Camera.minZoom = minZoom;

    // let maxZoom = limitToMaxZoom(10000);
    // console.log('calculated maxZoom ===> ', maxZoom);
    // mapView.Camera.maxZoom = maxZoom;

}



/**
 * @param { MapView } mapView
 */
function addLabels(mapView) {
  // console.log('RECOLOR 2 ===> ');

  if (!mapView) {
    return;
  }
  
  let venue = mapView.venue;
  if (!venue) {
    return;
  }




  // mapView.FloatingLabels.labelAllLocations();

  // mapView.FlatLabels.labelAllLocations({
  //   appearance: {
  //     font: "Georgia",
  //     fontSize: 16,
  //     color: "#1c1c43"
  //   }
  // });


  let iconSvg_Rocket = `<?xml version="1.0" encoding="UTF-8"?><svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" width="512" height="512" viewBox="0 0 24 24"><path d="M15.5,6c-1.378,0-2.5,1.122-2.5,2.5s1.122,2.5,2.5,2.5,2.5-1.122,2.5-2.5-1.122-2.5-2.5-2.5Zm0,4c-.827,0-1.5-.673-1.5-1.5s.673-1.5,1.5-1.5,1.5,.673,1.5,1.5-.673,1.5-1.5,1.5ZM24,2.5c0-1.378-1.122-2.5-2.514-2.5-4.942,.141-9.444,2.552-13.111,7.001-1.586,.019-3.168,.404-4.585,1.115-2.302,1.155-3.79,3.661-3.79,6.384v.5H5c1.068,0,2.073,.416,2.829,1.171,.755,.756,1.171,1.76,1.171,2.829v5h.5c2.723,0,5.229-1.487,6.384-3.789,.712-1.417,1.096-3,1.115-4.586,4.448-3.667,6.86-8.17,7.001-13.125ZM4.238,9.01c1.034-.519,2.165-.845,3.317-.961-.098,.132-.196,.265-.293,.4-1.553,2.167-2.712,4.684-3.092,5.551H1.019c.166-2.15,1.393-4.074,3.219-4.99Zm10.752,10.752c-.917,1.826-2.84,3.053-4.99,3.219v-3.151c.868-.38,3.384-1.539,5.552-3.092,.135-.097,.268-.194,.4-.292-.116,1.152-.442,2.283-.961,3.317Zm-.021-3.837c-1.803,1.292-3.914,2.325-4.976,2.811-.064-1.236-.576-2.389-1.457-3.271-.882-.882-2.035-1.393-3.271-1.457,.486-1.062,1.519-3.173,2.811-4.976C10.629,5.469,15.033,1.184,21.5,1c.827,0,1.5,.673,1.5,1.486-.184,6.481-4.469,10.885-8.031,13.439ZM1.732,18.732c-.85,.849-1.419,3.881-1.524,4.48l-.124,.703,.703-.124c.599-.105,3.631-.674,4.48-1.524,.472-.472,.732-1.1,.732-1.768s-.26-1.296-.732-1.768c-.943-.944-2.592-.944-3.535,0Zm2.828,2.828c-.386,.386-1.934,.831-3.227,1.106,.275-1.293,.72-2.841,1.106-3.227,.283-.283,.66-.439,1.061-.439s.777,.156,1.061,.439,.439,.66,.439,1.061-.156,.777-.439,1.061Z"/></svg>`;
  let iconSvg_Freezer = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-wind"><path d="M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"></path></svg>`;
  let iconSvg_Defrostings = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-clock"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>`;
  let iconSvg_Layups = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-film"><rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect><line x1="7" y1="2" x2="7" y2="22"></line><line x1="17" y1="2" x2="17" y2="22"></line><line x1="2" y1="12" x2="22" y2="12"></line><line x1="2" y1="7" x2="7" y2="7"></line><line x1="2" y1="17" x2="7" y2="17"></line><line x1="17" y1="17" x2="22" y2="17"></line><line x1="17" y1="7" x2="22" y2="7"></line></svg>`;






  // mapView.FloatingLabels.labelAllLocations({
  //   appearance: {
  //     marker: {
  //       icon: iconSvg,
  //       iconSize: 16,
  //       backgroundColor: {
  //         active: "transparent",
  //         // active: "white",
  //         inactive: "transparent"
  //       },
  //       foregroundColor: {
  //         // active: "blue",
  //         active: "transparent",
  //         inactive: "transparent"
  //       },
  //     },
  //     text: {
  //       size: 14,
  //       lineHeight: 14,
  //       // backgroundColor: "#000000",
  //       // foregroundColor: "#FFFFFF",
  //       // backgroundColor: "transparent",
  //       // foregroundColor: "#666666",
  //       backgroundColor: "#FFFFFF",
  //       foregroundColor: "#666666",
  //       // backgroundColor: "aqua",
  //       // foregroundColor: "yellow",
  //     }
  //   }

  // });



  venue.polygons.forEach((p) => {


    let location = p.locations[0];
    if (!location) {
      return;
    }

    console.log('p.locations[0] ===> ', location);
    let locationName = location.name;
    let locationType = location.type;
    // let displayString = `${locationName} - ( ${locationType} )`;
    let displayString = locationName;

    let svgIcon = iconSvg_Rocket;

    if (locationType === `freezers`) {
      svgIcon = iconSvg_Freezer;
    }
    if (locationType === `layups`) {
      svgIcon = iconSvg_Layups;
    }
    if (locationType === `defrostings`) {
      svgIcon = iconSvg_Defrostings;
    }


    mapView.FloatingLabels.add(p, displayString, {

      appearance: {
        marker: {
          icon: svgIcon,
          iconSize: 16,
          backgroundColor: {
            active: "transparent",
            // active: "white",
            inactive: "transparent"
          },
          foregroundColor: {
            // active: "blue",
            active: "transparent",
            inactive: "transparent"
          },
        },
        text: {
          size: 14,
          lineHeight: 14,
          // backgroundColor: "#000000",
          // foregroundColor: "#FFFFFF",
          // backgroundColor: "transparent",
          // foregroundColor: "#666666",
          backgroundColor: "#FFFFFF",
          foregroundColor: "#666666",
          // backgroundColor: "aqua",
          // foregroundColor: "yellow",
        }
      }

    });










    // if (p.externalId?.toUpperCase() === 'CUT & KIT E347') {

    //   // console.log(' WWWWWWWWWWWWWWWWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZAAAAAAAAAAAAAAAAAAAA ===> ');


    //   let location = p.locations[0];

    //   console.log('p.locations[0] ===> ', location);
    //   let locationName = location.name;
    //   let locationType = location.type;
    //   let displayString = `${locationName} - ( ${locationType} )`;

    //   mapView.FloatingLabels.add(p, displayString, {
    //     // appearance: {
    //     //   font: "Georgia",
    //     //   fontSize: 16,
    //     //   color: "#1c1c43"
    //     // }
    //   });
    // }


  });



}


/**
 * @param { MapView } mapView
 */
function recolorMap(mapView) {
  // console.log('RECOLOR 2 ===> ');

  if (!mapView) {
    return;
  }
  
  let venue = mapView.venue;
  if (!venue) {
    return;
  }

  // printVenueData(venue);


  /**
   * @type {string[]}
   */
  let balconyWallPolys = [];


  // /**
  //  * @type {any[]}
  //  */
  // let problemPolys = [];

  ////////////////////////////////////
  // Color polygons of interest
  //
  venue.polygons.forEach((p) => {




    // if (p.id == `654ea33a501b8e970aebadda` || p.id == `654ea33a501b8e970aebaddc`) {
    //   // mapView.setPolygonHoverColor(p, "#FFD5DB");
    //   mapView.setPolygonColor(p, "#FF0000");
    //   problemPolys.push(p);
    // }


    // if (p.id == `654ea33a501b8e970aebadda`) {
    //   // mapView.setPolygonHoverColor(p, "#FFD5DB");
    //   mapView.setPolygonColor(p, "#FF0000");
    //   // problemPolys.push(p);
    // }

    // if (p.id == `654ea33a501b8e970aebaddc`) {
    //   // mapView.setPolygonHoverColor(p, "#FFD5DB");
    //   mapView.setPolygonColor(p, "#FF0000");
    //   problemPolys.push(p);
    // }






    // if (p.layer === "Shelves") {
    //   // mapView.setPolygonHoverColor(p, "#FFD5DB");
    //   mapView.setPolygonColor(p, "#27f2f9");
    // }






    if (p.layer === "Room") {
      // mapView.setPolygonHoverColor(p, "#FFD5DB");
      mapView.setPolygonColor(p, "#D2E8F6");
      // mapView.setPolygonHoverColor(p, "#333");
    }

    if (p.layer === "PL_Stations") {
      // mapView.setPolygonHoverColor(p, "#FFD5DB");
      mapView.setPolygonColor(p, "#8796A4");
      // mapView.setPolygonHoverColor(p, "#333");
    }

    if (p.layer === "PL_Freezers") {
      // mapView.setPolygonHoverColor(p, "#FFD5DB");
      mapView.setPolygonColor(p, "#93C9F0");
      // mapView.setPolygonHoverColor(p, "#333");
    }

    if (p.layer === "PL_Sections") {
      // mapView.setPolygonHoverColor(p, "#FFD5DB");
      mapView.setPolygonColor(p, "#D2E8F6");
      // mapView.setPolygonHoverColor(p, "#333");
    }

    if (p.layer === "Wall") {
      // mapView.setPolygonHoverColor(p, "#FFD5DB");
      // mapView.setPolygonColor(p, "#efefef");
      // mapView.setPolygonColor(p, "#AAAAAA");
      // mapView.setPolygonColor(p, "#F3EEE8");


      // if (p.map.shortName === "L1") {
      //   // mapView.setPolygonColor(p, "aqua");

      //   let externalId = p.externalId ? p.externalId : 'UNDEFINED';
      //   let message = `${p.id} - ${externalId}`;
      //   balconyWallPolys.push(message);

      //   // Problematic balcony walls.
      //   if (p.id == `654ea33a501b8e970aebadda` || p.id == `654ea33a501b8e970aebaddc`) {
      //     return;
      //   }


      //   // return;
      // }


      mapView.setPolygonColor(p, "#D9DCE3");
    }

    if (p.layer === "Furniture") {
      // mapView.setPolygonHoverColor(p, "#FFD5DB");
      mapView.setPolygonColor(p, "#E0D021");
    }

    if (p.layer === "Floor") {
      // mapView.setPolygonHoverColor(p, "#FFD5DB");
      // mapView.setPolygonColor(p, "#E2E2E2");
      mapView.setPolygonColor(p, "#FFFFFF");
    }

    if (p.layer === "Non Public") {
      // mapView.setPolygonHoverColor(p, "#FFD5DB");
      mapView.setPolygonColor(p, "#F3EEE8");
    }

    if (p.layer === "Elevator") {
      // mapView.setPolygonHoverColor(p, "#FFD5DB");
      // mapView.setPolygonColor(p, "#0000FF");
      mapView.setPolygonColor(p, "#569CFF");
    }

    if (p.layer === "Stairs") {
      // mapView.setPolygonHoverColor(p, "#FFD5DB");
      // mapView.setPolygonColor(p, "#80ff80");
      mapView.setPolygonColor(p, "#555555");
    }

  });


  // console.log('balconyWallPolys ===> ', balconyWallPolys);
  // console.log('problemPolys ===> ', problemPolys);


}


/**
 * @param { MapView } mapView
 */
function addMapInteractivity(mapView) {
  // console.log('INTERACTIVITY 2 ===> ');

  if (!mapView) {
    return;
  }
  
  let venue = mapView.venue;
  if (!venue) {
    return;
  }

  //////////////////////////////////////////////////////////
  // Add interactivity to polygons of interest
  //
  venue.polygons.forEach((p) => {

    // if (p.layer === "Shelves") {
    //   mapView.addInteractivePolygon(p);
    // }

    if (p.layer === "Furniture") {
      mapView.addInteractivePolygon(p);
    }
    if (p.layer === "Room") {
      mapView.addInteractivePolygon(p);
    }

    if (p.layer === "PL_Stations") {
      mapView.addInteractivePolygon(p);
    }

    if (p.layer === "PL_Sections") {
      mapView.addInteractivePolygon(p);
    }

    if (p.layer === "PL_Freezers") {
      mapView.addInteractivePolygon(p);
    }




  });

}



/**
 * @param { Mappedin } venue
 */

function getLayerNames(venue) {

  /**
   * @type {(string)[]}
   */
  const layers = [];
  venue.polygons.forEach((p) => {
    if (!p.layer) {
      return;
    }
    if (!layers.includes(p.layer)) {
      layers.push(p.layer);
    }
  });
  return layers;
}



/**
 * @param { Mappedin } venue
 */
function getMapsOrderedByElevationDesc(venue) {
  let maps = venue.maps.slice().sort((a, b) => b.elevation - a.elevation);
  return maps;
}


/**
 * @param { Mappedin } venue
 */
function printVenueData(venue) {

  let layerNames = getLayerNames(venue);
  // console.log('LAYERS ===> ', layerNames);

  let mapsByElevation = getMapsOrderedByElevationDesc(venue);
  // console.log('MAPSBYELEVATION ===> ', mapsByElevation);

  console.log('VENUE DATA ===> ', {
    layerNames,
    mapsByElevation
  });

}



// function getLabelStyleByLocationType(locationType) {

//   let style = {
//     marker: {
//       icon: iconSvg_Rocket,
//       iconSize: 16,
//       backgroundColor: {
//         active: "transparent",
//         // active: "white",
//         inactive: "transparent"
//       },
//       foregroundColor: {
//         // active: "blue",
//         active: "transparent",
//         inactive: "transparent"
//       },
//     },
//     text: {
//       size: 14,
//       lineHeight: 14,
//       // backgroundColor: "#000000",
//       // foregroundColor: "#FFFFFF",
//       // backgroundColor: "transparent",
//       // foregroundColor: "#666666",
//       backgroundColor: "#FFFFFF",
//       foregroundColor: "#666666",
//       // backgroundColor: "aqua",
//       // foregroundColor: "yellow",
//     }
//   };

//   if (locationType === `freezers`) {
//     style.marker.icon = iconSvg_Freezer;
//   }
//   if (locationType === `layups`) {
//     style.marker.icon = iconSvg_Layups;
//   }
//   if (locationType === `defrostings`) {
//     style.marker.icon = iconSvg_Defrostings;
//   }

//   return style;
// }



